import reduxStore from "utils/storeFactory";
import { getChapterEntity } from "selectors/chapter/makeGetChapterEntity";
import getActiveSlideIndex from "selectors/chapter/slideshow/getActiveSlideIndex";

export default function getMediaId(input) {
  const { playbackState, chapterId } = input;

  let result;

  const reduxState = reduxStore.getState();
  const isSingleVideoPlayer = reduxState.playerOptions.singleVideoPlayer;
  const chapterEntity = getChapterEntity(reduxState, { chapterId });
  if (!chapterEntity) {
    throw new Error("calling getMediaId with no chapterEntity");
  }
  if (isSingleVideoPlayer) {
    result = chapterEntity.video;
  } else if (chapterEntity.type === "slideshow") {
    const activeSlideIndex = getActiveSlideIndex(reduxState, { chapterId });
    result = chapterEntity.slides[activeSlideIndex];
  } else if (chapterEntity.type === "video") {
    result = chapterId;
  } else if (chapterEntity.type === "interview") {
    const question = playbackState.currentQuestion;
    if (!question) return null;
    result = question.id;
  } else if (chapterEntity.type === "pathfinder") {
    if (chapterEntity.introductionVideo) {
      result = chapterEntity.introductionVideo.id;
    } else {
      result = chapterEntity.loopVideo.id;
    }
  }

  if (DEVELOPMENT) {
    if (!result) {
      result = "fake";
    }
  }

  return result;
}
